import ClevertapObject from '@/src/analytics/clevertap'
import { getDeviceType } from '@/src/utils/api/getDeviceType'
import { getUserAuthValues } from '@/src/utils/auth'
import { getCookie } from '@/src/utils/browser'
import { getUserSelectedCurrencyCode } from '@/src/utils/currency/getCurrencyCode'
import { getAppAgent, getPlatformName } from '@/src/utils/deviceType'
import { isEmpty } from '@/src/utils/generalUtils'
import { isInternalUser, isUserSignedIn } from '@/src/utils/generalUtils/checkUserLogin'
import { path } from '@/src/utils/generalUtils/path'
import { getuuid } from '@/src/utils/generalUtils/uuid'
import { logError } from '@/src/utils/logError'
import { useLocale } from 'next-intl'
import { useCallback } from 'react'

const useClevertapEvent = () => {
    const { userId } = getUserAuthValues()
    const language = useLocale()
    const domain = typeof window !== 'undefined' ? path(['location', 'hostname'], window) || 'NA' : 'NA'
    const isCtLoginUser = isInternalUser()
    const is_logged_in = isUserSignedIn() ? 'yes' : 'no'
    const [email] = is_logged_in === 'yes' ? decodeURIComponent(getCookie('userid') || '').split('|') : []
    const channel = process.env.NEXT_PUBLIC_VARIANT
    const id = getuuid()

    const triggerEvent = useCallback(
        (name: string, payload: any) => {
            const deviceType = getDeviceType()
            const platform = getPlatformName(deviceType)
            const userAgent = getAppAgent(deviceType)
            const source = ['PWA', 'DESKTOP'].includes(userAgent) ? 'web' : 'app'
            const clevertapPayload = {
                domain,
                language, 
                is_logged_in,
                userId,
                isCtLoginUser,
                id,
                channel,
                currency: getUserSelectedCurrencyCode() || 'NA',
                userPrefCurrency: getCookie('utm_currency') || 'N/A',
                platform,
                source,
                email: email || '',
                ctNewFlow_abCookie: getCookie('abtest') || 'N/A',
                ...payload,
            }
            ClevertapObject.event(name, clevertapPayload)
        },
        [domain, language, is_logged_in, userId, isCtLoginUser, id, channel, getUserSelectedCurrencyCode, getCookie]
    )
    return { triggerEvent }
}

export default useClevertapEvent
